import React from "react";

import { Route, Switch, Redirect } from "react-router-dom";
import { getToken } from "utils/storage";

//政策汇总
import Policy from "pages/policy";
import Exchange from "pages/exchange";
import Comminicate from "pages/comminicate";
import PolicyDetails from "pages/policy/details";
import Information from "pages/information";
// import InformationDetails from 'pages/information/details';
import NotFound from "pages/notfound/404.js";
//首页
import Home from "pages/home";
import EntList from "pages/home/entList"; // 重点推荐企业列表
import PromiseBook from "pages/home/promiseBook"; //承诺书界面
import PromiseBookDetail from "pages/home/promiseBookDetail"; //承诺书界面详情
import SkillsTrainingApply from "pages/skillsTrainingApply";
import BusinessBehalf from "pages/home/businessBehalf";
import BusinessBehalfDetail from "pages/home/businessBehalfDetail";

//教育培训联盟
import EducationTrainingAlliance from "pages/educationTrainingAlliance";
//教育培训联盟详情
import EducationTrainingAllianceDetail from "pages/educationTrainingAlliance/detail";

//招聘会
import JobFair from "pages/jobFair";
//招聘会详情
import JobFairDetail from "pages/jobFair/jobFairDetail";
// 政务服务
import GovernmentService from "pages/governmentService";
// 优惠服务
import PreferentialProducts from "pages/preferentialProducts";
// 产品详情
import ProductsDetail2 from "pages/preferentialProducts/detail2";

import PreferentialProductsList from "pages/preferentialProducts/products";
import ProductsDetail from "pages/preferentialProducts/detail";
//便民服务
import convenience from "pages/convenience";
// 搜索
import SearchResult from "pages/searchResult";
// 地图
import Map from "pages/map";
//创业帮扶
import createAssist from "pages/createAssist";
//创业帮扶-金融服务
import assistanceFinance from "pages/createAssist/assistanceFinance";
//创业帮扶-专家
import assistanceExpert from "pages/createAssist/assistanceExpert";
//创业帮扶---创业服务申请--详情
import createDetails from "pages/createAssist/createAssistItem";
//创业帮扶---创业基地--详情
import ImbarkBaseDetails from "pages/createAssist/ImbarkBaseDetails";
//创业帮扶---创业基地--申请入驻
import AssistLication from "pages/createAssist/AssistLication";
//创业帮扶---创业专家
import EntrepreneurialExpert from "pages/createAssist/EntrepreneurialExpert";
//创业帮扶---创业专家----详情
import EntrepreneurialExpertDetails from "pages/createAssist/EntrepreneurialExpertDetails";
//创业帮扶----创业金融服务
import FinancialService from "pages/createAssist/FinancialService";
//创业帮扶----创业金融服务----详情
import FinancialServiceDetails from "pages/createAssist/FinancialServiceDetails";
//创业帮扶----创业金融服务----详情
import FinancialServiceDetailsNew from "pages/createAssist/FinancialServiceDetailsNew";
//创业帮扶----创业金融服务----眉山市退役军人创业基金管理暂行办法
import FinancialServiceArticle from "pages/createAssist/FinancialServiceArticle";
//创业帮扶----创业基金----详情
import StartFundApplication from "pages/createAssist/StartFundApplication";
//就业招聘
// import getJob from "pages/getjob";
import getJob from "pages/getjob/webLink";
//就业招聘---职位详情
import PositionDetails from "pages/getjob/positionDetails/JobDetail";
//就业招聘---企业详情
import CompanyDetails from "pages/getjob/companyDetails/JobDetail";

import Preferential from "pages/preferential/preferential";
import Search from "pages/preferential/search";
//个人中心模块
import { Personal } from "pages/userCenter/personal";
import UserInfo from "pages/userCenter/personal/userInfo/index";
import ResumeManage from "pages/userCenter/personal/resumeManage/";
import MyDelivery from "pages/userCenter/personal/myDelivery";
import JobCollection from "pages/userCenter/personal/jobCollection";
// import CourseLearningRecords from 'pages/userCenter/personal/courseLearningRecords';
import ApplyTrainingRecords from "pages/userCenter/personal/applyTrainingRecord";
import BusinessTourRecords from "pages/userCenter/personal/businessTourRecords/";
// import InformationDetails from "pages/userCenter/personal/informationDetails";

//招聘企业模块
import RecruitEnterprise from "pages/userCenter/recruitEnterprise";
import EnterpriseInfo from "pages/userCenter/recruitEnterprise/enterpriseInfo";
import JobDetail from "pages/userCenter/recruitEnterprise/jobDetail";
import JobPublish from "pages/userCenter/recruitEnterprise/jobPublish";

// import ServiceProvider from 'pages/userCenter/serviceProvider';
import Application from "pages/preferential/application";
import PreferentialDetail from "pages/preferential/preferentialDetail";
import PreferentialInfo from "pages/preferential/preferentialInfo";

import PreferentialPolicy from "pages/preferential/preferentialPolicy";
import PreferentialPolicyDetail from "pages/preferential/preferentialPolicyDetail";
import PreferentialInformationDetail from "pages/preferential/preferentialInformationDetail";
import ApplicationProcess from "pages/preferential/applicationProcess";
import ApplicationGuide from "pages/preferential/applicationGuide";
import DeucationTrainingInfoDetail from "pages/educationTraining/deucationTrainingDetail";
import DeucationTrainingInfo from "pages/educationTraining/deucationTrainingInfo";
import DeucationTrainingPolicy from "pages/educationTraining/deucationTrainingPolicy";
import DeucationTrainingPolicyDetail from "pages/educationTraining/deucationTrainingPolicyDetail";
import EducationTrainingOrganization from "pages/educationTraining/educationTrainingOrganization";
import EduDetail from "pages/educationTraining/eduOrganizationDetail";
import EduInlineDetail from "pages/educationTraining/eduInlineDetail";

import Reset from "pages/password/reset";

import Success from "pages/password/success";
import Find from "pages/password/find";
import Step from "pages/password/step";

import xfapplication from "pages/xfapplication";

import workservice from "pages/workService";

import main from "pages/main";

// 教育培训
import educationTraining from "pages/educationTraining/educationTraining";
import Result from "pages/educationTraining/result";
import ResultDetail from "pages/educationTraining/resultDetail";
import TrainingApplication from "pages/educationTraining/trainingApplication";
import PoliciesDetails from "pages/educationTraining/policiesDetails";
import TrainingGuide from "pages/educationTraining/trainingGuide";
import TrainingHandle from "pages/educationTraining/trainingHandle";
import TextSearch from "pages/textSearch";

let routerConfig = [
  { path: "/", title: "首页", exact: true, component: Home },
  { path: "/home", title: "首页", exact: true, component: Home },
  {
    path: "/entList",
    title: "重点企业推荐",
    exact: true,
    component: EntList,
  },
  {
    path: "/promiseBook",
    title: "教育培训联盟",
    exact: true,
    component: PromiseBook,
  },
  {
    path: "/promiseBookDetail",
    title: "教育培训联盟-详情",
    exact: true,
    component: PromiseBookDetail,
  },
  {
    path: "/businessBehalf",
    title: "就业创业优秀代表",
    exact: true,
    component: BusinessBehalf,
  },
  {
    path: "/businessBehalfDetail",
    title: "就业创业优秀代表详情",
    exact: true,
    component: BusinessBehalfDetail,
  },
  {
    path: "/educationTrainingAllianceDetail/:id",
    title: "教育培训联盟详情",
    exact: true,
    component: EducationTrainingAllianceDetail,
  },
  {
    path: "/educationTrainingAlliance",
    title: "教育培训联盟",
    exact: true,
    component: EducationTrainingAlliance,
  },
  {
    path: "/skillsTrainingApply/:type",
    title: "技能培训申请表",
    exact: true,
    component: SkillsTrainingApply,
  },
  { path: "/main", title: "个人中心", component: main },
  // { path: '/complaint', title: '投诉建议', component: complaint },
  { path: "/jobFair", title: "招聘会", component: JobFair },
  { path: "/jobFairDetail", title: "招聘会详情", component: JobFairDetail },

  {
    path: "/governmentService",
    title: "政务服务",
    component: GovernmentService,
  },
  {
    path: "/employment",
    title: "就业招聘",
    exact: true,
    component: getJob,
  },
  // {
  //   path: "/entrepreneurship",
  //   title: "创业服务申请",
  //   exact: true,
  //   component: createAssist,
  // },
  {
    path: "/entrepreneurship",
    title: "创业帮扶列表",
    exact: true,
    component: createAssist,
  },
  {
    path: "/assistanceFinance",
    title: "创业金融服务",
    exact: true,
    component: assistanceFinance,
  },
  {
    path: "/assistanceExpert",
    title: "创业服务支持",
    exact: true,
    component: assistanceExpert,
  },
  {
    path: "/entrepreneurship/assistItem/:id",
    title: "创业服务申请详情",
    exact: true,
    component: createDetails,
  },
  {
    path: "/entrepreneurship/ImbarkBaseDetails/:id",
    title: "创业服务申请详情",
    component: ImbarkBaseDetails,
  },
  {
    path: "/entrepreneurship/AssistLication/:id",
    title: "创业服务申请入驻",
    component: AssistLication,
  },
  {
    path: "/entrepreneurship/EntrepreneurialExpert",
    title: "创业专家",
    exact: true,
    component: EntrepreneurialExpert,
  },
  {
    path: "/entrepreneurship/EntrepreneurialExpertDetails/:id",
    title: "创业专家详情",
    exact: true,
    component: EntrepreneurialExpertDetails,
  },
  {
    path: "/entrepreneurship/FinancialService",
    title: "创业金融服务",
    exact: true,
    component: FinancialService,
  },
  {
    path: "/entrepreneurship/FinancialServiceDetails/:id",
    title: "创业金融服务详情",
    exact: true,
    component: FinancialServiceDetails,
  },
  {
    path: "/entrepreneurship/FinancialServiceDetailsNew/:id",
    title: "创业金融服务详情",
    exact: true,
    component: FinancialServiceDetailsNew,
  },
  {
    path: "/entrepreneurship/FinancialServiceArticle",
    title: "眉山市退役军人创业基金管理暂行办法",
    exact: true,
    component: FinancialServiceArticle,
  },
  {
    path: "/entrepreneurship/StartFundApplication/:id",
    title: "创业金融服务详情",
    exact: true,
    component: StartFundApplication,
  },
  {
    path: "/employment/positionDetails/:id",
    title: "职位详情",
    exact: true,
    component: PositionDetails,
  },
  {
    path: "/employment/companyDetails/:id",
    title: "职位详情",
    exact: true,
    component: CompanyDetails,
  },
  { path: "/policy", title: "政策法规", component: Policy },
  { path: "/policyDetails", title: "政策法规详情", component: PolicyDetails },

  { path: "/reset", title: "修改密码", component: Reset },
  { path: "/success", title: "重置成功", component: Success },
  { path: "/find", title: "找回密码", component: Find },
  { path: "/step", title: "验证", component: Step },
  { path: "/personal", title: "个人中心", component: Personal, auth: true }, //个人中心路由
  {
    path: "/personal/resumeManage",
    title: "简历管理",
    component: ResumeManage,
    auth: true,
  },
  {
    path: "/personal/myDelivery",
    title: "我的投递",
    component: MyDelivery,
    auth: true,
  },
  {
    path: "/personal/jobCollection",
    title: "职位收藏",
    component: JobCollection,
    auth: true,
  },

  {
    path: "/personal/applyTrainingRecords",
    title: "申请培训记录",
    component: ApplyTrainingRecords,
    auth: true,
  },
  { path: "/education", title: "教育培训", component: educationTraining },
  //
  {
    path: "/educationPoliciesDetails",
    title: "教育培训政策",
    component: PoliciesDetails,
  },
  {
    path: "/educationInfoDetail",
    title: "教育培训",
    component: DeucationTrainingInfoDetail,
  },
  {
    path: "/educationInfo",
    title: "教育培训",
    component: DeucationTrainingInfo,
  },
  {
    path: "/educationPolicy",
    title: "教育培训",
    component: DeucationTrainingPolicy,
  },
  {
    path: "/educationPolicyDetail",
    title: "教育培训",
    component: DeucationTrainingPolicyDetail,
  },
  {
    path: "/educationOrganization",
    title: "教育培训",
    component: EducationTrainingOrganization,
  },
  {
    path: "/eduDetail",
    title: "线下课程详情",
    component: EduDetail,
  },
  {
    path: "/eduInlineDetail",
    title: "线上课程详情",
    component: EduInlineDetail,
  },
  { path: "/result", title: "结果查询", component: Result },
  { path: "/resultDetail", title: "结果查询详情", component: ResultDetail },
  {
    path: "/trainingApplication",
    title: "教育培训",
    component: TrainingApplication,
  },

  {
    path: "/personal/businessTourRecords",
    title: "创业巡诊记录",
    component: BusinessTourRecords,
  },

  { path: "/reset", title: "修改密码", component: Reset },
  { path: "/success", title: "重置成功", component: Success },
  { path: "/find", title: "找回密码", component: Find },
  { path: "/step", title: "验证", component: Step },

  //招聘企业路由
  {
    path: "/recruitEnterprise",
    title: "企业信息管理",
    component: RecruitEnterprise,
  },
  {
    path: "/recruitEnterprise/enterpriseInfo",
    title: "企业信息管理",
    component: EnterpriseInfo,
  },
  {
    path: "recruitEnterprise/jobDetail",
    title: "职位详情",
    component: JobDetail,
  },

  {
    path: "recruitEnterprise/JobPublish",
    title: "职位详情",
    component: JobPublish,
  },
];
let prefix = "";
const getRouter = () => (
  <Switch>
    {routerConfig.map((item, index) => {
      return (
        <Route
          key={index}
          path={prefix + "/entrance" + item.path}
          exact={item.exact}
          // exact
          component={item.component}
        />
      );
    })}
  </Switch>
);

const getRouterAPP = () => (
  <Switch>
    <Route path="/appXfapplication" component={xfapplication} />
  </Switch>
);
export { getRouter, getRouterAPP };
